<template>
  <div class="product">
    <div class="product-box">
      <div class="title">
        {{resDatas.title}}
      </div>
      <div class="game-box">
        <ul class="gameul">
          <li class="product-list" v-for="(item,index) in resDatas.newsList" >
            <router-link :to='"/new-details?id="+ index' class="gameIconbox">
              <img class="gameIcon"  :src="require('@/assets/images/news/' + item.img)">
            </router-link>
            <div class="product-text">
              <router-link :to='"/new-details?id="+ index'>
                <h3 v-html="item.title"></h3>
              </router-link>
              <p>{{item.minicontent}}</p>
            </div>
            <router-link class="tobut" :to='"/new-details?id="+ index'>
              {{resDatas.toText}}
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  export default{
    data(){
      return{
        resDatas:''
      }
    },
    props: {
        resData: {}
    },
    watch: {
        resData(newData){
          console.log(newData)
          this.resDatas=newData;
        }
    },
    methods:{

    },
    mounted() {
      this.$parent.getlan();
    }
  }
</script>

<style scoped>
  .product{
    background: url('~@/assets/images/news/bg3.jpg') top center no-repeat;
    background-size: cover;
    padding: 5% 0 5%;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .product-box {
    width: 100%;
  }
  .game-box{
    max-width: 80%;
    margin:5% auto;
    box-sizing: border-box;
    background-color: rgba(39, 39, 39, 0.12);
    border-radius: 10px;
  }
  .gameul{
    padding: 2%;
    box-sizing: border-box;
    height: 100%;
  }
  .product-list{
    padding: 2% 4% 2%;
    font-size: 0;
    position: relative;
    display: flex;
    align-items: center;
  }

  .product-list::after{
    content: '';
    display: block;
    clear: both;
  }
  .title{
    font-size: 70px;
    text-align: center;
    background: url('~@/assets/images/title-bottom.png') center bottom no-repeat;
    background-size: auto;
    font-family: 'dbtfont';
    padding-bottom: 10px;
  }
  .product-main{
    display: inline-block;
    vertical-align: middle;
    margin-left: 5%;
  }
  .product-banner{
    padding: 2%;
  }
  .product-banner img{
    width: 100%;
    display: block;
  }
  .product-text{
    font-size: 16px;
    word-break: break-all;
    display: inline-block;
    width: 54%;
    margin-left: 3%;
    vertical-align: top;
    padding-bottom: 5px;
  }
  .product-text h3{
    font-size: 32px;
    color: #000;
    word-break: break-word;
    overflow-wrap: break-word; /* 允许单词内部断行 */
    hyphens: auto; /* 自动断字 */
    white-space: pre-wrap; /* 保留空白符序列，同时正常换行 */
  }
  .product-text p{
    font-size: 26px;
    margin-top: 1%;
  }
  .product-download{
    margin-top: 2%;
    display: inline-block;
    margin-left: 3%;
    width: 80%;
  }
  .product-download .download-title{
    color: #5B6E88;
    font-size: 20px;
    text-align: center;
    background-color: white;
    padding: 1% 0;
    font-weight: 600;
  }
  .download-box{
    font-size: 20px;
    display: flex;
    align-items: center;
  }
  .download-box a{
    display: inline-block;
    cursor: pointer;
    width: 30%;
    background-color: black;
    border-radius: 5px;
    position: relative;
  }
  .download-box a:nth-of-type(2){
    margin: 0 10%;
  }
  .download-box a img{
    width: 100%;
    display: block;
  }
  .product-list .gameIconbox{
    width: 25%;
    display: block;
  }
  .gameIcon{
    width: 100%;
    display: inline-block;
  }
  .download-box span{
    color: white;
    position: absolute;
    z-index: 2;
    width: 100%;
    display: block;
    top: 50%;
    transform: translateY(-50%);
    text-align: center;
  }
  .web-img{
    opacity: 0;
  }
  .tobut{
    background-color: #000;
    font-size: 18px;
    display: block;
    position: absolute;
    padding: 16px 30px ;
    color: white;
    border-radius: 5px;
    top: 50%;
    right: 2%;
    transform: translateY(-50%);
    cursor: pointer;
  }
  @media screen and (max-width: 1000px){
    .product{
      background: url('~@/assets/images/news/h5-bg3.jpg') top center no-repeat;
      background-size: 100%;
      padding: 0 5% 5%;
      padding-top: 15%;
      padding-bottom: 15%;
    }
    .product-list{
      padding: 10% 3%;
      display: block;
    }

    .product-download{
      width: 100%;
      margin-left: 0;
      margin-top: 5%;
    }
    .download-box a:nth-of-type(2){
      margin:0 3%;
    }
    .product-list .gameIconbox{
      width: 70%;
      height: auto;
      float: initial;
      margin-left: 15%;
    }
    .gameIcon{
      width: 100%;
      display: block;
    }
    .download-box span{
      font-size: 14px;
    }
    .game-box{
      max-width: 100%;
    }
    .title{
      font-size: 30px;
      background: url('~@/assets/images/yd-title-bottom.png') center bottom no-repeat;
      background-size: 30%;
    }
    .product-text{
      width: 100%;
      margin-left: 0;
      margin-top: 2%;
      display: block;
    }
    .product-text h3{
      font-size: 18px;
      text-wrap: balance;
      text-align: left;
      margin-top: 5%;
      word-break: break-word;
      overflow-wrap: break-word; /* 允许单词内部断行 */
      hyphens: auto; /* 自动断字 */
      white-space: pre-wrap; /* 保留空白符序列，同时正常换行 */
    }
    .product-text p{
      font-size: 18px;
      margin-top: 1%;
    }
    .tobut{
      font-size: 16px;
      display: inline-block;
      position: relative;
      color: white;
      border-radius: 5px;
      top: 0%;
      left: 50%;
      transform: translateX(-50%);
      cursor: pointer;
      margin:5% auto 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/news.vue